// re.rejouis.fr — inscription newsletter Klaviyo, UNIQUEMENT sur case cochée par
// le client (consentement actif RGPD : case non cochée par défaut, jamais liée à
// la demande de reprise). Endpoint client Klaviyo → clé PUBLIQUE (company_id),
// pas de backend, pas de secret exposé.

const KLAVIYO_COMPANY_ID = 'TW8kCX';
// Liste « Liste adresse email (pop up + newsletter) » — la même que la pop-up rejouis.fr.
const LISTE_NEWSLETTER = 'XMt8Jt';

// Le choix est fait AVANT la connexion (écran Vérifications) mais l'e-mail n'est
// connu qu'après : on le garde le temps de l'aller-retour OAuth.
const CLE_CHOIX = 'rejouis_reprise_newsletter';

export function memoriserChoixNewsletter(oui) {
  try {
    if (oui) localStorage.setItem(CLE_CHOIX, '1');
    else localStorage.removeItem(CLE_CHOIX);
  } catch { /* stockage indisponible : on n'inscrit pas, c'est le bon sens de l'erreur */ }
}

export function lireEtOublierChoixNewsletter() {
  try {
    const oui = localStorage.getItem(CLE_CHOIX) === '1';
    localStorage.removeItem(CLE_CHOIX);
    return oui;
  } catch {
    return false;
  }
}

// Best-effort : un échec ne doit jamais gêner la demande de reprise.
export async function abonnerNewsletter(email) {
  if (!email) return false;
  try {
    const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 're.rejouis – tunnel de reprise',
            // Pas de champ `subscriptions` ici : l'endpoint client le refuse (400) ;
            // l'inscription à la liste vaut consentement marketing e-mail.
            profile: { data: { type: 'profile', attributes: { email } } },
          },
          relationships: { list: { data: { type: 'list', id: LISTE_NEWSLETTER } } },
        },
      }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
